import { Component, OnInit } from "@angular/core";
import { AlertService } from "../../service/shared/alert.service";

@Component({
  selector: "app-tela-inicial",
  templateUrl: "./tela-inicial.component.html",
  styleUrls: ["./tela-inicial.component.scss"],
})
export class TelaInicialComponent implements OnInit {
  constructor(private _alertService: AlertService) {}

  ngOnInit() {
    // this._alertService.messageV2(
    //   "** ATENÇÃO **",
    //   "O servidor passará por manutenção dia 21/05/2024 às 00:00h",
    //   "warning"
    // );
  }
}
